import { Page } from 'components/common/Criterias/types';
import { MarkupPages } from 'store/markupRules/types';

const base = 'markup';

const getTestId = (name: string) => `${base}_${name}`;

const markupTestIds = {
	addButton: (page: string) => (page !== Page.Checklists ? getTestId('addGroup') : getTestId('addChecklists')),
	importButton: (page: string) =>
		page === MarkupPages.Tags ? getTestId('importTagRules') : getTestId('importDicts'),
	addItemButton: (page: string) => (page === MarkupPages.Dicts ? getTestId('addDict') : getTestId('addTaggingRule')),
	pageNav: (page: string) => getTestId(`nav_${page}`),
	itemsSearch: (page: string) => getTestId(`${page}_search}`),
	itemsSort: (page: string) => getTestId(`${page}_sort}`),
	importUserSelect: () => getTestId('importUserSelect'),
	importNav: (page: string) => getTestId(`importNav_${page}`),
	importItemsSearch: (page: string) => getTestId(`${page}_importSearch}`),
	newRuleInput: () => getTestId('newRuleInput'),
	newRuleApply: () => getTestId('newRuleApply'),
	newRuleCancel: () => getTestId('newRuleCancel'),
};

export default markupTestIds;
